// @ts-nocheck
import { GetInvoicesApiParameter } from "@insite/client-framework/Services/InvoiceService";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<GetInvoicesApiParameter>;

export const DispatchUpdateDraftParameter: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/InvoiceHistory/UpdateDraftParameter",
        parameter: props.parameter,
    });
};

export const chain = [DispatchUpdateDraftParameter];

const updateDraftParameter = createHandlerChainRunner(chain, "UpdateDraftParameter");
export default updateDraftParameter;
